import React from 'react';
import { StoryblokComponent } from 'gatsby-source-storyblok';
import { useStoryblokStory } from '../../../hooks';

const CartMessageWrapper: React.FC = () => {
  const { storyblokStoryData } = useStoryblokStory('cart-message');

  return (
    storyblokStoryData?.content && (
      <div>
        <StoryblokComponent blok={storyblokStoryData.content} />
      </div>
    )
  );
};

export default CartMessageWrapper;
